export var BodyObjectType;
(function (BodyObjectType) {
    BodyObjectType[BodyObjectType["Block"] = 0] = "Block";
    BodyObjectType[BodyObjectType["Line"] = 1] = "Line";
    BodyObjectType[BodyObjectType["Separator"] = 2] = "Separator";
})(BodyObjectType || (BodyObjectType = {}));
